const SectionScroll = {

  activeIndex: null,
  activeSectionBlockIndex: null,
  resizeTimeout: null,
  previousScrollY: null,
  scrollYOnPause: null,
  initialTouchY: null,
  heroHeight: null,
  breakpoints: {},
  blockBreakpoints: {},
  navBar: null,
  offset: 0.7,
  fadeTimeout: null,
  scrollStopTimeout: null,
  wrapper: null,
  isMobile: false,
  scrollInProgress: false,
  jumpingToSection: false,
  scrollPauseOnTitle: false,

  init: () => {
    const sectionLinks = document.querySelectorAll('.scroll-section-quick-link');
    if (sectionLinks) {
      sectionLinks.forEach((sectionLink) => {
        sectionLink.addEventListener('click', SectionScroll.handleSectionClick);
        sectionLink.addEventListener('touchend', SectionScroll.handleSectionClick);
        sectionLink.addEventListener('mouseenter', (e) => {
          SectionScroll.handleSectionDotHover(e.target, true);
        });
        sectionLink.addEventListener('mouseleave', (e) => {
          SectionScroll.handleSectionDotHover(e.target, false);
        });
      });
    }
    SectionScroll.numSections = sectionLinks.length;
    SectionScroll.wrapper = document.getElementById('section-scroll-videos');
    SectionScroll.navBar = document.getElementById('section-scroll-nav');
    if ( SectionScroll.navBar ) {
      SectionScroll.navBar.classList.add('animated');
    }
    SectionScroll.arrowPrev = document.getElementById('section-scroll-prev');
    SectionScroll.arrowNext = document.getElementById('section-scroll-next');
    SectionScroll.previousScrollY = window.scrollY;
    SectionScroll.calculateBreakpoints();
    SectionScroll.makeScrollIndicatorClickable();

    //SectionScroll.handleSectionScroll();
    SectionScroll.setActiveSectionBasedOnScrollPosition();
    window.addEventListener('resize', () => {
      clearTimeout(SectionScroll.resizeTimeout);
      SectionScroll.resizeTimeout = setTimeout(() => {
        SectionScroll.calculateBreakpoints();
      }, 100);
    });
    window.addEventListener('keyup', (e) => {
      if (
        e.code === 'Tab'
      ) {
        SectionScroll.handleTabPress(e);
      } else if ( ['ArrowDown', 'ArrowUp'].includes(e.code) ) {
        SectionScroll.handleArrowPress(e);
      }
    });
    document.addEventListener('scroll', SectionScroll.handleSectionScroll, { passive: false })
    
    SectionScroll.handleScrollBarScrub();

    SectionScroll.setupNavArrows();

    window.addEventListener('wheel', (e) => {
      SectionScroll.handleWheelScroll(e)
    }, { passive: false });
    window.addEventListener('touchstart', SectionScroll.handleInitialTouch);
    window.addEventListener('touchend', (e) => {
      SectionScroll.handleWheelScroll(e)
    }, { passive: false });

  },
  updateActiveSection: ( newIndex ) => {
    if ( newIndex === null || typeof newIndex === 'undefined' || newIndex === SectionScroll.activeIndex) {
      //console.log('cant load null index');
      return;
    }

    const tempBodyClass = 'active-section-is-changing';
    document.body.classList.add( tempBodyClass );

    const prevIndex = SectionScroll.activeIndex;
    if (prevIndex!==null) {
      SectionScroll.toggleSection( prevIndex, false );
    }

    /*
    This hid the nav bar on the first screen, but client wants it to always show.
    if (newIndex===0) {
      SectionScroll.navBar.classList.remove('active');
    } else {
      SectionScroll.navBar.classList.add('active');
    }
    */

    SectionScroll.toggleSection( newIndex, true );
    SectionScroll.activeIndex = newIndex;

    setTimeout(() => {
      document.body.classList.remove( tempBodyClass );
    }, 400);

  },

  handleTabPress(e) {
    let parentEl = e.target.parentNode;
    let targetBlock = null;
    let count = 0;
    while ( ( parentEl.nodeName !== 'BODY' && targetBlock === null ) || count > 50) {
      parentEl = parentEl.parentNode;
      if (parentEl.classList.contains('section-block')) {
        targetBlock = parentEl;
      }
      count ++;
    }
    if (targetBlock!==null) {
      const targetIndexes = targetBlock.id.replace('scroll-section-block-', '').split('-');
      const targetActiveIndex = parseInt(targetIndexes[0]);
      const targetActiveSectionBlockIndex = parseInt(targetIndexes[1]);
      if (
        this.activeIndex !== targetActiveIndex ||
        this.activeSectionBlockIndex !== targetActiveSectionBlockIndex
      ) {
        //SectionScroll.doUpdateSections( nextIndex, nextSectionBlockIndex, scrollDirection, currentOffset )

        const offset = SectionScroll.getScrollToOffset( targetActiveSectionBlockIndex );
        window.scrollTo({
          top: SectionScroll.blockBreakpoints[targetActiveIndex][targetActiveSectionBlockIndex] + offset,
          left: 0,
          behavior: "instant",
        });

        SectionScroll.setActiveSectionBasedOnScrollPosition();

      }
    }
  },

  handleArrowPress(e) {
    if (
      document.body.classList.contains('menuactive')
    ) return;
    const direction = (e.code==='ArrowUp') ? 'up' : 'down';
    const targetArrowId = 'section-scroll-' + ((direction==='up') ? 'prev' : 'next');
    const targetArrow = document.getElementById(targetArrowId);
    if (targetArrow) {
      targetArrow.click();
    }
  },

  updateActiveSectionBlock: ( newIndex, newSectionBlockIndex, scrollDirection ) => {
    if ( newIndex === null || typeof newIndex === 'undefined' || newSectionBlockIndex === null || typeof newSectionBlockIndex === 'undefined' ) {
      //console.log('cant load null index - newIndex: ' + newIndex + ' newSectionBlockIndex: ' + newSectionBlockIndex );
      return;
    }

    if (newSectionBlockIndex >= 1) {
      SectionScroll.wrapper.parentNode.classList.remove('title-in-view');
      SectionScroll.pauseActiveVideo(null);
    } else {
      SectionScroll.wrapper.parentNode.classList.add('title-in-view');
      SectionScroll.wrapper.classList.remove('faded');
    }
    //if (newSectionBlockIndex===SectionScroll.activeSectionBlockIndex) return;
    SectionScroll.activeSectionBlockIndex = newSectionBlockIndex;
    const activeSectionBlock = document.querySelector('.section-block.active');
    if (activeSectionBlock) {
      activeSectionBlock.classList.remove('active');
      if (scrollDirection==='down') {
        activeSectionBlock.classList.add('viewed');
      }
    }

    const targetSectionBlock = document.getElementById('scroll-section-block-' + newIndex + '-' + newSectionBlockIndex);
    if (targetSectionBlock) {
      targetSectionBlock.classList.add('active');
      targetSectionBlock.classList.remove('viewed');
    }

  },

  pauseActiveVideo: (video) => {
    if (video===null) {
      video = document.querySelector('#section-video-' + SectionScroll.activeIndex + ' video');
    }
    if (video) {
      clearTimeout(SectionScroll.fadeTimeout);   
      SectionScroll.wrapper.classList.add('faded');
    }
  },

  toggleSection: ( sectionIndex, active ) => {
    clearTimeout(SectionScroll.fadeTimeout);
    const videoWrapper = document.getElementById( 'section-video-' + sectionIndex );
    const video = videoWrapper.querySelector('video');
    const freezeOnFrame1 = false; //(sectionIndex === 0 && videoWrapper.classList.contains('video-as-still'));
    const toggleElements = document.querySelectorAll('.section-toggle-item-' + sectionIndex);
    if (active) {
      videoWrapper.classList.add('active');
      if (video.src==='') {
        video.src = video.dataset.src;
        video.load();
        video.currentTime = 0;
        if (active === true && !freezeOnFrame1 && sectionIndex !== SectionScroll.activeIndex) {
          video.play();
          if (sectionIndex!==0) {
            SectionScroll.pauseActiveVideo(video);
            SectionScroll.wrapper.classList.add('faded');
          }
        }
      } else {
        if (active === true) {
          video.currentTime = 0;
        }
      }
      toggleElements.forEach((item) => {
        item.classList.add('active');
      });
    } else {
      videoWrapper.classList.remove('active');
      toggleElements.forEach((item) => {
        item.classList.remove('active');
      });
    }
  },

  setActiveSectionBasedOnScrollPosition: () => {

    const currentOffset = window.scrollY;
    let nextIndex = 0;
    let nextSectionBlockIndex = 0;
    const scrollDirection = (currentOffset > SectionScroll.previousScrollY) ? 'down' : 'up';

    // Calculate which section is active based on breakpoints
    Object.values(SectionScroll.breakpoints).forEach((breakpoint, breakpointIndex) => {
      //console.log('direction: ' + scrollDirection + ' current: ' + currentOffset + ' next: ' + breakpoint);
      if (scrollDirection === 'down' && currentOffset > breakpoint) {
        nextIndex = breakpointIndex;
      } else if (scrollDirection === 'up' && currentOffset > (SectionScroll.breakpoints[breakpointIndex] - 1)) {
        nextIndex = breakpointIndex;
      }
    });
    if (typeof SectionScroll.blockBreakpoints[nextIndex] !== 'undefined') {
      //console.log('direction: ' + scrollDirection + ' current: ' + currentOffset + ' next: ' + blockBreakpoint);
      Object.values(SectionScroll.blockBreakpoints[nextIndex]).forEach((blockBreakpoint, blockBreakpointIndex) => {
        if (scrollDirection === 'down' && currentOffset > blockBreakpoint) {
          nextSectionBlockIndex = blockBreakpointIndex || 0;
        } else if (scrollDirection === 'up') {
          if (currentOffset > (SectionScroll.blockBreakpoints[nextIndex][blockBreakpointIndex] + 1)) {
            nextSectionBlockIndex = blockBreakpointIndex || 0;
          }
        }
      });
    }

    //console.log(nextIndex + ' ' + SectionScroll.activeIndex + ' ---- ' + nextSectionBlockIndex + ' ' + SectionScroll.activeSectionBlockIndex)

    SectionScroll.doUpdateSections( nextIndex, nextSectionBlockIndex, scrollDirection, currentOffset )
  },

  setActiveSectionBasedOnNextPrev: (scrollDirection = null) => {

    const currentOffset = window.scrollY;
    SectionScroll.resetScrollStopListener();

    let nextIndex = (SectionScroll.activeIndex===null) ? 0 : SectionScroll.activeIndex;
    let nextSectionBlockIndex = (SectionScroll.activeSectionBlockIndex===null) ? 0 : SectionScroll.activeSectionBlockIndex;

    if (scrollDirection===null) {
      scrollDirection = (currentOffset > SectionScroll.previousScrollY) ? 'down' : 'up';
    }

    // Calculate which section is active based on scroll direction
    if (scrollDirection === 'down') {
      nextSectionBlockIndex = nextSectionBlockIndex + 1;
      const sectionBreakpoints = SectionScroll.blockBreakpoints[nextIndex];

      if (typeof SectionScroll.blockBreakpoints[nextIndex][nextSectionBlockIndex] === 'undefined') {
        nextIndex = SectionScroll.activeIndex + 1;
        nextSectionBlockIndex = 0;
      }
    } else {
      if (nextIndex < 0) {
        nextIndex = 0;
        nextSectionBlockIndex = 0;
      } else {
        nextSectionBlockIndex = nextSectionBlockIndex - 1;
        if (typeof SectionScroll.blockBreakpoints[nextIndex][nextSectionBlockIndex] === 'undefined') {
          nextIndex = nextIndex - 1;
          nextSectionBlockIndex = (typeof SectionScroll.blockBreakpoints !== 'undefined' && typeof SectionScroll.blockBreakpoints[nextIndex] !== 'undefined') ? Object.values(SectionScroll.blockBreakpoints[nextIndex]).length - 1 : 0;
        }
        if (nextIndex < 0) {
          nextIndex = 0;
          nextSectionBlockIndex = 0;
        }
        if (
          nextIndex===1 && 
          SectionScroll.activeIndex===1 &&
          nextSectionBlockIndex === 0 &&
          SectionScroll.activeSectionBlockIndex === 0
        ) {
          nextIndex = 0;
        }
      }
    }

    if (typeof SectionScroll.blockBreakpoints[nextIndex] === 'undefined') return;

    const offset = SectionScroll.getScrollToOffset( nextSectionBlockIndex );
    window.scrollTo({
      top: SectionScroll.blockBreakpoints[nextIndex][nextSectionBlockIndex] + offset,
      left: 0,
      behavior: "instant",
    });

    SectionScroll.doUpdateSections( nextIndex, nextSectionBlockIndex, scrollDirection, currentOffset )
  },

  getScrollToOffset( nextSectionBlockIndex ) {
    return (SectionScroll.isMobile && nextSectionBlockIndex === 1) ? 0 : 200;
  },

  doUpdateSections( nextIndex, nextSectionBlockIndex, scrollDirection, currentOffset ) {
    if (nextIndex===0) {
      document.body.classList.add('is-on-splash-screen');
    } else {
      document.body.classList.remove('is-on-splash-screen');
    }
    SectionScroll.updateActiveSection( nextIndex )
    SectionScroll.updateActiveSectionBlock( nextIndex, nextSectionBlockIndex, scrollDirection )
    SectionScroll.previousScrollY = currentOffset;
    SectionScroll.toggleArrowStates();
  },

  /**
   * We save the initialTouchY so we can determine the y change on 
   * touch devices to get the direction.
   */
  handleInitialTouch(e) {
    if (
      SectionScroll.shouldUseScrollMode()
    ) return;
    SectionScroll.initialTouchY = e.touches[0].clientY;
  },

  /**
   * This helper function determines whether the scroll mode 
   * should be used or not. In general it is used for mobile, and for 
   * the splash screen. The rest uses handleWheelScroll logic.
   */
  shouldUseScrollMode() {
    if ( !SectionScroll.isMobile ) return false;
    if ( SectionScroll.activeIndex === 0 ) return false;
    return true;
  },

  /**
   * This logic is used for desktop sizes. Instead of scrolling, they jump 
   * screen by screen through all of the sections.
   */
  handleWheelScroll: (e) => {

    if (
      SectionScroll.jumpingToSection
    ) {
      return;
    }


    if (
      SectionScroll.shouldUseScrollMode()
    ) {
      return;
    }

    if (
      SectionScroll.scrollInProgress &&
      typeof e.deltaY !== 'undefined'
    ) return;

    SectionScroll.scrollInProgress = true;

    let direction = 'down';
    if (typeof e.deltaY !== 'undefined') {
      direction = (e.deltaY >= 0) ? 'down' : 'up';
    } else {
      const newTouchY = e.changedTouches[0].clientY;
      direction = (newTouchY < SectionScroll.initialTouchY) ? 'down' : 'up';
    }
    
    SectionScroll.setActiveSectionBasedOnNextPrev(direction);

    SectionScroll.resetScrollStopListener();

  },

  /**
   * This logic is mainly used for medium down screen size, which 
   * uses regular scroll.
   */
  handleSectionScroll: (e) => {

    if (
      !SectionScroll.shouldUseScrollMode()
    ) return;

    const currentOffset = window.scrollY;

    if (
      SectionScroll.jumpingToSection
    ) {
      SectionScroll.previousScrollY = currentOffset;
      SectionScroll.resetScrollStopListener();
      return;
    }

    let nextIndex = 0;
    let nextSectionBlockIndex = 0;
    const scrollDirection = ( currentOffset > SectionScroll.previousScrollY ) ? 'down' : 'up';
    
      SectionScroll.scrollInProgress = true;
      if ( SectionScroll.isMobile ) {
        SectionScroll.setActiveSectionBasedOnScrollPosition();
      } else {
        SectionScroll.setActiveSectionBasedOnNextPrev(scrollDirection);
      }

    SectionScroll.resetScrollStopListener();

  },

  toggleFirstSectionVisibility: (isVisible = false) => {
    const videos = document.getElementById('section-scroll-videos');
    const navButtons = document.getElementById('section-scroll-nav');
    const firstSection = document.getElementById('scroll-section-0');
    if (isVisible) {
      videos.classList.remove('not-visible');
      navButtons.classList.remove('not-visible');
      firstSection.classList.remove('not-visible');
    } else {
      videos.classList.add('not-visible');
      navButtons.classList.add('not-visible');
      firstSection.classList.add('not-visible');
    }
  },

  /**
   * This function handles setting scrollInProgress to true. There is a
   * delay set up so that the scroll handlers can be deactivated. Otherwise 
   * a scroll would shoot down to the bottom of the page.
   */
  resetScrollStopListener: () => {
    SectionScroll.scrollInProgress = true;
    clearTimeout(SectionScroll.scrollStopTimeout);
    const timeoutDelay = ( SectionScroll.isMobile ) ? 50 : 1200;
    SectionScroll.scrollStopTimeout = setTimeout(
      SectionScroll.handleScrollStop,
      timeoutDelay
    );
  },

  /**
   * Set scrolling to be ended.
   */
  handleScrollStop: () => {
    SectionScroll.scrollInProgress = false;
  },

  /**
   * This makes the navigation title change to the hovered item 
   * on hover, instead of the active one.
   */
  handleSectionDotHover: (element, isActive) => {
    const activeTitle = document.querySelector('.section-nav-title.active');
    const targetNum = element.dataset.sectionNumber;
    const hoverTitle = document.getElementById('section-nav-title-' + targetNum);
    if (isActive) {
      if (activeTitle) activeTitle.classList.add('hide-for-hover');
      hoverTitle.classList.add('hover-active');
    } else {
      if (activeTitle) activeTitle.classList.remove('hide-for-hover');
      hoverTitle.classList.remove('hover-active');
    }
  },


  /**
   * This adds the arrows and attaches listeners.
   */
  setupNavArrows: () => {

    const prevArrow = document.getElementById('section-scroll-prev');
    if (prevArrow) {
        prevArrow.addEventListener('click', (e) => {
          e.preventDefault();
          SectionScroll.setActiveSectionBasedOnNextPrev('up');
        });
    }

    const nextArrow = document.getElementById('section-scroll-next');
    if (nextArrow) {
        nextArrow.addEventListener('click', (e) => {
          e.preventDefault();
          SectionScroll.setActiveSectionBasedOnNextPrev('down');
        });
    }

  },

  /**
   * This disables the up arrow on the first screen and the down 
   * arrow on the last screen.
   */
  toggleArrowStates() {
    if ( SectionScroll.activeIndex === 0 ) {
      SectionScroll.toggleArrowDisabledState( 'arrowPrev', true );  
      SectionScroll.toggleArrowDisabledState( 'arrowNext', false );
    } else if ( 
      SectionScroll.activeIndex === SectionScroll.numSections
    ) {
      const numSubBlocks = Object.values(SectionScroll.blockBreakpoints[SectionScroll.activeIndex]).length;
      SectionScroll.toggleArrowDisabledState( 'arrowPrev', false );
      const isNextArrowDisabled = ( parseInt( numSubBlocks - 1 ) == parseInt( SectionScroll.activeSectionBlockIndex ) );
      SectionScroll.toggleArrowDisabledState( 'arrowNext', isNextArrowDisabled );
    } else {
      SectionScroll.toggleArrowDisabledState( 'arrowPrev', false );  
      SectionScroll.toggleArrowDisabledState( 'arrowNext', false );
    }
  },

  /**
   * Helper function for toggleArrowStates.
   */
  toggleArrowDisabledState( key, isDisabled ) {
      SectionScroll[key].disabled = isDisabled;
      if (isDisabled) {
        SectionScroll[key].classList.add('disabled');
      } else {
        SectionScroll[key].classList.remove('disabled');
      }
  },

  /**
   * Navigate to the selected section in the timeline on click. We set the 
   * jumpingToSection boolean to true so we can pause the other listeners 
   * during the travel time.
   */
  handleSectionClick: (e) => {
    SectionScroll.jumpingToSection = true;
    SectionScroll.toggleFirstSectionVisibility(false);

    const nextChapterIndex = parseInt(e.target.dataset.sectionNumber);

    window.scrollTo({
      top: SectionScroll.blockBreakpoints[nextChapterIndex][0] + 200,
      behavior: "instant",
    });

    SectionScroll.setActiveSectionBasedOnScrollPosition();

    setTimeout(() => {
      SectionScroll.toggleFirstSectionVisibility(true);
      SectionScroll.jumpingToSection = false;
    }, 100);
  },

  /**
   * This handles navigating to the correct part of the page 
   * when the user drags the scrollbar.
   */
  handleScrollBarScrub() {
    document.addEventListener('mousedown', (e) => {
      if (e.target.nodeName==='HTML') {
        SectionScroll.jumpingToSection = true;
      }
    });
    document.addEventListener('mouseup', (e) => {
      if (e.target.nodeName==='HTML') {
        SectionScroll.jumpingToSection = false;
        SectionScroll.setActiveSectionBasedOnScrollPosition();
      }
    });
  },


  /**
   * This sets up breakpoints that help allow the class to determine what 
   * section is active based on the y value of the page.
   */
  calculateBreakpoints: () => {
    SectionScroll.isMobile = (window.innerWidth < 971);
    const sections = document.querySelectorAll('.scroll-section-wrapper');
    const offsetAmount = ( window.innerHeight * SectionScroll.offset );
    SectionScroll.heroHeight = sections[0].getBoundingClientRect().height;
    sections.forEach((section, sectionIndex) => {
      SectionScroll.breakpoints[sectionIndex] = section.offsetTop - (window.innerHeight - offsetAmount); // - offsetAmount;
      const sectionBlocks = document.querySelectorAll('#scroll-section-' + sectionIndex + ' .section-block');
      if (sectionBlocks) {
        sectionBlocks.forEach((sectionBlock, sectionBlockIndex) => {
          if (typeof SectionScroll.blockBreakpoints[sectionIndex] === 'undefined') {
            SectionScroll.blockBreakpoints[sectionIndex] = {}
          }
          const offsetDown = section.offsetTop + sectionBlock.offsetTop - (window.innerHeight - offsetAmount);
          SectionScroll.blockBreakpoints[sectionIndex][sectionBlockIndex] = offsetDown;
        });
      }
    });
    SectionScroll.setActiveSectionBasedOnScrollPosition();
  },

  makeScrollIndicatorClickable() {
    const button = document.getElementById('scroll-down-indicator-text');
    if (button) {
      button.addEventListener('click', () => {
        SectionScroll.setActiveSectionBasedOnNextPrev('down');
      });
    }
  }

}

SectionScroll.init();